import { render, staticRenderFns } from "./component-text-link.vue?vue&type=template&id=129a0917&scoped=true&"
import script from "./component-text-link.vue?vue&type=script&lang=js&"
export * from "./component-text-link.vue?vue&type=script&lang=js&"
import style0 from "./component-text-link.vue?vue&type=style&index=0&id=129a0917&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a0917",
  null
  
)

export default component.exports